export default "__VITE_ASSET__1204f884__"